<template>
  <div>
    <table class="calendar">
      <tr
        v-for="(entry, index) in calendar"
        :key="index"
        :class="{today: isToday(entry.date), tomorrow: isTomorrow(entry.date)}">
        <td>{{ formattedDate(entry.date) }}</td>
        <td>{{ entry.title }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['calendar']),
  },
  data() {
    return {
      today: moment(),
      tomorrow: moment().add(1, 'days'),
    };
  },
  mounted() {
    const midnight = new Date();
    midnight.setHours(0, 0, 0, 0);
    const delay = 24 * 60 * 60 * 1000 - ((new Date()).getTime() - midnight.getTime());
    setTimeout(() => {
      setInterval(() => this.updateDates(), 60 * 60 * 1000);
    }, delay);
  },
  methods: {
    formattedDate(date) {
      return moment(date).format('ddd DD.MM');
    },
    isToday(date) {
      return moment(date).isSame(this.today, 'day');
    },
    isTomorrow(date) {
      return moment(date).isSame(this.tomorrow, 'day');
    },
    updateDates() {
      this.today = moment();
      this.tomorrow = moment().add(1, 'days');
    },
  },
};
</script>

<style scoped>
.calendar td {
  font-size: 15pt;
  text-align: left;
  white-space: nowrap;
}
.calendar td:first-child {
  padding-right: 15px;
}
.calendar tr.today td {
  color: #8ec8ff;
}
.calendar tr.tomorrow td {
  color: #ffa30f;
}
</style>
